module.exports = __webpack_public_path__ + "img/sol.4ba6b25e.svg";